export const RoadsideAssistanceMappings: Record<string, string> = {
  stella_ratecomp_roadsideAssistance_standard: "Roadside Assistance Standard",
  stella_ratecomp_roadsideAssistance_premium: "Roadside Assistance Premium"
}
